






















import { mapState } from "vuex";
import { Vue, Component, Prop } from "vue-property-decorator";
import IconBase from "@/common/components/atoms/IconBase.vue";
import commons from "@/common/store/modules/commons";

@Component({
  components: {
    IconBase
  },
  computed: {
    ...mapState({
      storeIconColor: state => commons.color
    })
  }
})
export default class ButtonMain extends Vue {
  @Prop({ type: String, required: false, default: "button" }) tag!: string;
  @Prop({ type: String, required: false, default: "main" }) kind!: string;
  @Prop({ type: Boolean, required: false, default: false }) disabled!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) grayOut!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) noborder!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) autoWidth!: boolean;
  storeIconColor: string;

  get childTag() {
    const { tag } = this;
    return tag === "button" ? "span" : "div";
  }
  emitClickEvent() {
    this.$emit("click-button");
  }
  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get iconColor() {
    if(this.isGroupBudget) {
      return 'bisque'
    }
    return this.storeIconColor
  }
}
